<template>
  <SectionPage :img="img" :content="content" :btn="btn" :icon="icon"/>
</template>

<script>
import SectionPage from '@/layout/SectionPage.vue'
export default {
  name: "Section2",
  components: {
    SectionPage
  },
  data() {
    return {
      img: require('@/assets/section-bg/section2.jpeg'),
      content: {
        componentsType: {
          pc: 'shortBtn sectionBtn',
          mobile: 'shortBtn sectionBtn'
        },
        title: '02\nGOALS',
        text: 'Let us know your nutrition goals so we can provide you with more accurate nutrition advice.'
      },
      btn:{
        text: 'Next',
        link: '/questionnaire/section2/1',
      },
      icon: require('@/assets/icon/section-02.png')
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
